import firebase from './firebase';
import store from '@/store';
const db = firebase.database();
const messaging = firebase.messaging();
messaging.usePublicVapidKey('BLt22vnIeAneNW6gEVoRVL_ydSfzTZq7NTK8wxj4mm7HQBI1S2KIpI9d0etfICcE-lLH6VcvoyrjgvErTkeVNuA');
let getAndSendTokenTimeout;
export async function subscribeToNotifications() {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
        getAndSendToken();
        // Ping the backend each minute to let it know that the user is still here
        getAndSendTokenTimeout = window.setTimeout(getAndSendToken, 60000);
    }
    else {
        console.log('Unable to get permission to notify.');
    }
}
export async function unsubscribeFromNotifications() {
    clearTimeout(getAndSendTokenTimeout);
    sendTokenToServer(null);
    const token = await messaging.getToken();
    await messaging.deleteToken(token);
}
function getAndSendToken() {
    messaging.getToken().then(token => sendTokenToServer(token));
}
function sendTokenToServer(token) {
    console.info('sending token to server: users/' + firebase.auth().currentUser.uid);
    db.ref('users/' + firebase.auth().currentUser.uid).update({
        messagingToken: token,
        tokenUpdated: firebase.database.ServerValue.TIMESTAMP
    });
}
messaging.onMessage((payload) => {
    console.log('Message received... ', payload);
    store.dispatch('autoAssignConversation', payload.data);
});
messaging.onTokenRefresh(async (arg) => {
    console.info('!!!!!!!!!!!!!!! token refreshed', arg);
    try {
        const refreshedToken = await messaging.getToken();
        console.log('Token refreshed.');
        // // Send Instance ID token to app server.
        sendTokenToServer(refreshedToken);
    }
    catch (err) {
        console.log('Unable to retrieve refreshed token ', err);
        // showToken('Unable to retrieve refreshed token ', err);
    }
});
//# sourceMappingURL=messaging.js.map